import React from 'react';
import SimpleCard from '../teal-react/components/organisms/SimpleCard';
import { CloseOutlined } from '@mui/icons-material';
import BatchViewer from './BatchViewer';
import Utils from '../teal-react/utils';
import Typo from '../teal-react/components/atoms/Typo';
import { useQc } from '../graphql/queries';
import Loading from '../teal-react/components/molecules/Loading';
import K from '../Constants';
import CertificateViewer from './CertificateViewer';
import PdfWrapper from './layout/PdfWrapper';
import BatchNotesManager from './BatchNotesManager';
import TestingReport from './TestingReport';
import SimplePosition from '../teal-react/components/atoms/SimplePosition';
import { Button } from '@mui/material';
import BatchEditor from './BatchEditor';
import ExcludeReadOnly from './Auth/ExcludeReadOnly';

const QcViewer = ({ id, onClose }: { id: number; onClose: () => void }) => {
  const [tab, setTab] = React.useState(2);
  const [batchEdit, setBatchEdit] = React.useState(false);
  const { data } = useQc(id);
  const qc = data?.qc?.[0];
  React.useEffect(() => {
    if (qc?.status === K.status.CANCELLED) {
      // potential bug if trying to view cancelled batch
      onClose();
    }
    // eslint-disable-next-line
  }, [qc?.status]);

  if (!data) {
    return <Loading />;
  }

  const tabs = [
    { label: 'Testing Report', onClick: () => setTab(2) },
    { label: 'Batch', onClick: () => setTab(1) },
  ];
  if (qc.status === K.status.APPROVED) {
    tabs.push(
      ...[
        { label: 'COA', onClick: () => setTab(3) },
        { label: 'COC', onClick: () => setTab(4) },
        { label: 'COO', onClick: () => setTab(5) },
      ]
    );
  }
  return (
    <>
      <SimpleCard
        raised
        header={`${qc.qc_code} : [${qc.product.code}] ${qc.product.name}`}
        subheader={
          <>
            <div className="row">
              <div className="col">
                {Typo.label_value_stack(
                  'Quantity',
                  `${qc.amount || 'Unknown'} ${qc.unit?.name || ''}`
                )}
              </div>
              <div className="col">
                {Typo.label_value_stack('Status', qc.status)}
              </div>
              <div className="col">
                {Typo.label_value_stack(
                  'Date',
                  Utils.date.formatDate(qc.date) || ''
                )}
              </div>
              <div className="col">
                {Typo.label_value_stack(
                  'Created',
                  Utils.date.formatDate(qc.created_at) || ''
                )}
              </div>
              <div className="col">
                {Typo.label_value_stack(
                  'Tested',
                  Utils.date.formatDate(qc.tested_at) || '(Pending)'
                )}
              </div>
              <div className="col">
                {Typo.label_value_stack(
                  'Approved',
                  Utils.date.formatDate(qc.approved_at) || '(Pending)'
                )}
              </div>
              <div className="col">
                {Typo.label_value_stack('By', qc.approved_by || '')}
              </div>
            </div>
          </>
        }
        headeraction={{
          icon: <CloseOutlined />,
          onClick: onClose,
        }}
        tabs={tabs}
      >
        {tab === 1 ? (
          batchEdit ? (
            <div style={{ width: 792 /*match pdf size*/ }}>
              <BatchEditor qc_id={qc.id} onCancel={() => setBatchEdit(false)} />
            </div>
          ) : (
            <div>
              {qc.status === K.status.UNTESTED ||
              qc.status === K.status.QCONLY ? (
                <ExcludeReadOnly>
                  <SimplePosition position="top left" padding={10}>
                    <Button
                      variant="outlined"
                      onClick={() => setBatchEdit(true)}
                    >
                      Edit Batch
                    </Button>
                  </SimplePosition>
                </ExcludeReadOnly>
              ) : null}
              <PdfWrapper filename={`${qc.qc_code}-batch.pdf`}>
                <BatchViewer qc_id={qc.id} />
              </PdfWrapper>
            </div>
          )
        ) : null}
        {tab === 2 ? (
          <div className="row">
            <div className="col">
              <PdfWrapper
                filename={
                  qc.status === K.status.APPROVED
                    ? `${qc.qc_code}-report.pdf`
                    : undefined
                }
              >
                <TestingReport qc_id={qc.id} status={qc.status} />
              </PdfWrapper>
            </div>
            <div className="col_md" style={{ paddingLeft: 8 }}>
              <BatchNotesManager qc_id={qc.id} />
            </div>
          </div>
        ) : null}
        {tab === 3 ? (
          <PdfWrapper filename={`${qc.qc_code}-COA.pdf`}>
            <CertificateViewer qc_id={qc.id} type={'COA'} />
          </PdfWrapper>
        ) : null}
        {tab === 4 ? (
          <PdfWrapper filename={`${qc.qc_code}-COC.pdf`}>
            <CertificateViewer qc_id={qc.id} type={'COC'} />
          </PdfWrapper>
        ) : null}
        {tab === 5 ? (
          <PdfWrapper filename={`${qc.qc_code}-COO.pdf`}>
            <CertificateViewer qc_id={qc.id} type={'COO'} />
          </PdfWrapper>
        ) : null}
      </SimpleCard>
    </>
  );
};

export default QcViewer;
